import type { UrlObject } from "url"

/**
 * It is recommended that Next/Link is only used with internal URLs. Therefore there needs to be a way to
 * distinguish between internal/external URLs.
 *
 * This utility makes the termination
 */
export default function isExternalUrl(
  href: string | UrlObject | undefined,
): boolean {
  if (typeof href !== "string") return false // assume all UrlObjects are internal
  return !href.startsWith("/") && !href.startsWith("#")
}
